import axios from "axios";
const API_BASE_URL = "https://bimv6-api.ngrok.dev/api"; // ปรับตามจริง

const activeGetProjectsPromises = {};

const projectService = {
  // รับ companyName มาจาก caller โดยตรง — ไม่ยิง getUserProfile ซ้ำ
  getProjectsByCompany: async (companyName) => {
    const cacheKey = companyName || "__all__";
    if (activeGetProjectsPromises[cacheKey]) {
      return activeGetProjectsPromises[cacheKey];
    }

    const promise = (async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${API_BASE_URL}/getprojects`,
          { company_name: companyName },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        return response.data || [];
      } catch (err) {
        console.error("Error fetching projects:", err);
        throw err;
      } finally {
        delete activeGetProjectsPromises[cacheKey];
      }
    })();

    activeGetProjectsPromises[cacheKey] = promise;
    return promise;
  },

  getProjectMapByName: async (projectName) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/project-map/${projectName}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data; // จะได้ { project_name, lat, lng, ... }
    } catch (err) {
      console.error(`Error fetching map for ${projectName}:`, err);
      throw err;
    }
  },

  createProject: async (formData) => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(`${API_BASE_URL}/projects`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (err) {
      console.error("Error creating project:", err);
      throw err;
    }
  },

  getProjectById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/getProjectById/${id}`);
    return response.data;
  },

  // ── แก้ไขชื่อ project ──
  updateProject: async (id, formData) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${API_BASE_URL}/projects/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (err) {
      console.error("Error updating project:", err);
      throw err;
    }
  },

  // ── ลบ project ──
  deleteProject: async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(
        `${API_BASE_URL}/projects/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    } catch (err) {
      console.error("Error deleting project:", err);
      throw err;
    }
  },

  // ── เพิ่มช่างใน project ──
  addTechnician: async (id, technicianData) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.patch(
        `${API_BASE_URL}/projects/${id}`,
        technicianData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          }
        }
      );
      return response.data;
    } catch (err) {
      console.error("Error adding technician:", err);
      throw err;
    }
  },
};

export default projectService;
